// Section component to structure each content section with the correct "View All" link
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ContentGrid } from './ContentGrid';

export function Section({ title, viewAllPath, data }) {
  return (
    <Box sx={{ marginBottom: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">{title}</Typography>
        <Button
          size="small"
          component={RouterLink}
          to={viewAllPath}
        >
          VIEW ALL
        </Button>
      </Box>
      <ContentGrid
        data={data}
        viewAllPath={viewAllPath}
      />
    </Box>
  );
}
